import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { coachVerificationQueueParams } from "../../../admin-api/coach";
import { adminApi } from "../../../api-client";
import type { CoachVerificationStatus } from "../../../schemas/coach/verification";
import { queryKeys } from "../../query-keys";

export function useCoachVerificationQueue(status?: CoachVerificationStatus, offset = 0) {
	const params = { ...coachVerificationQueueParams(), offset, ...(status ? { status } : {}) };
	return useQuery({
		queryFn: () => adminApi.coach.verifications.list(params),
		queryKey: queryKeys.coachVerification.queue(params.status, params.limit, params.offset),
	});
}
export function useApproveCoachVerification() {
	const queryClient = useQueryClient();
	return useMutation({
		mutationFn: (userId: string) => adminApi.coach.verifications.approve(userId),
		onSuccess: () => queryClient.invalidateQueries({ queryKey: queryKeys.coachVerification.all }),
	});
}
export function useRejectCoachVerification() {
	const queryClient = useQueryClient();
	return useMutation({
		mutationFn: ({ userId, note }: { userId: string; note?: string }) =>
			adminApi.coach.verifications.reject(userId, note),
		onSuccess: () => queryClient.invalidateQueries({ queryKey: queryKeys.coachVerification.all }),
	});
}
